define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.uppercaseFirstChar = void 0;
    var uppercaseFirstChar = function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    exports.uppercaseFirstChar = uppercaseFirstChar;
});
//# sourceMappingURL=FiltersUppercaseFirstChar.js.map